<div class="row margin-0">
  <div class="col-md-12 padding-left-0 padding-right-0 margin-bottom-5 landing-nav-sticky">
    <div class="hpanel gs-card">
      <div class="mainNav panel-body gs-card-bodyborder-radius-top-left-right-6">
        <div class="navIteam">
          <h6 class="fw-bold">{{letterCaps(btnnameshow)}} :
            <span> {{count}}</span>
          </h6>
        </div>
        <div class="navIteam pos-rel-10">
          <input #txt (input)="keyupdata(txt.value)" type="text" class="form-control input-sm pd-lt-10 search-field-pad"
            placeholder="Search Network" aria-label="Amount (to the nearest dollar)" [(ngModel)]="searchContent"
            name="searchadmin" id="searchadmin" />
          <ng-icon name="tablerSearch" class="pos-rel-25"></ng-icon>
        </div>
        <div class="navIteam connectionbtn">
          <button class="btn btn-primary displayflex" *ngIf="userType != 'JOB_SEEKER'"
            (click)="openModalWithComponent()">
            <span class="mr-5"> </span> Create Network
          </button>
        </div>

        <div class="navIteam connectionbtn">
          <div class="btn-group unified-btn" dropdown container="body" placement="bottom right">

            <!-- Single Filter Button -->
            <button type="button" class="btn primary-btn filter-single-btn" dropdownToggle data-toggle="dropdown">

              <span>{{ letterCaps(btnnameshow) }}</span>
              <ng-icon name="tablerFilter"></ng-icon>

            </button>

            <!-- Dropdown -->
            <ul class="dropdown-menu no-padding dropdown-menu-right leftview" *dropdownMenu role="menu">

              <li role="menuitem">
                <a class="dropdown-item" [class.selected]="activeFilter === null" (click)="filterstatus(null)">
                  All
                </a>
              </li>

              <li role="menuitem">
                <a class="dropdown-item" [class.selected]="activeFilter === 'ACTIVE'" (click)="filterstatus('ACTIVE')">
                  Active Networks
                </a>
              </li>

              <li role="menuitem">
                <a class="dropdown-item" [class.selected]="activeFilter === 'INACTIVE'" (click)="filterstatus('INACTIVE')">
                  Deactive Networks
                </a>
              </li>

              <li role="menuitem">
                <a class="dropdown-item" [class.selected]="activeFilter === 'PENDING'" (click)="filterstatus('PENDING')">
                  Requests Received
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="col-sm-75 col-md-75 col-lg-75 padding-left-0 padding-right-0">
    <ng-container *ngIf="(connectionlistuserdata | async)?.length > 0">
      <div class="col-md-6 col-lg-3 padding-left-0 padding-right-5" infiniteScroll [infiniteScrollDistance]="4"
        [scrollWindow]="true" [infiniteScrollThrottle]="1000" (scrolled)="onScrollDown()"
        *ngFor="let data of (connectionlistuserdata | async);">
        <app-network-card (onSubmit)="onSubmit($event)" [userDataInput]="data"></app-network-card>
      </div>
    </ng-container>
    <ng-container *ngIf="loadAPIcall&&(connectionlistuserdata | async)?.length == 0">
      <div class="col-md-6 col-lg-3 padding-left-0 padding-right-5" style="margin-bottom: 5px;"
        *ngFor="let n of [1, 2, 3, 4, 5, 6, 7, 8]">
        <app-common-skeleton [NameOftheScreen]="'networkcard'"></app-common-skeleton>
      </div>
    </ng-container>
    <ng-container *ngIf="loadAPIcall&&(connectionlistuserdata | async)?.length > 0">
      <div class="col-md-6 col-lg-3 padding-left-0 padding-right-5" style="margin-bottom: 5px;"
        *ngFor="let n of [1, 2, 3, 4]">
        <app-common-skeleton [NameOftheScreen]="'networkcard'"></app-common-skeleton>
      </div>
    </ng-container>
    <ng-container *ngIf="(connectionlistuserdata | async)?.length === 0 && showNoDatafound">
      <app-nodata-found [title]="noDatafound">
      </app-nodata-found>
    </ng-container>

    <div class="col-sm-12 gs-end-of-list" *ngIf="stopScroll && (connectionlistuserdata | async)?.length > 0"
      style="text-align: center; padding-top: 1rem;">
      <div class="col-sm-12">
        <ng-icon name="tablerCircleCheck" class="end-of-list-icon"></ng-icon>
      </div>
      <div class="col-sm-12">
        <p class="biase">You've reached the bottom of the page</p>
      </div>
    </div>
  </div>


  <div class="col-sm-25 col-md-25 col-lg-25 padding-right-0 landing-sticky-widget">
    <div class="">
      <app-common-widget [page]="'NETWORK_PAGE'" [inputData]="'NETWORK'" [userType]="'ALL'"></app-common-widget>
    </div>
  </div>

</div>